import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-add98efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exception" }
const _hoisted_2 = {
  key: 0,
  class: "exception-image"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "exception-title"
}
const _hoisted_5 = {
  key: 2,
  class: "exception-description"
}
const _hoisted_6 = { class: "exception-actions" }
const _hoisted_7 = { class: "exception-button exception-button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "image", {}, () => [
            _createElementVNode("img", {
              src: _ctx.image,
              alt: "title"
            }, null, 8, _hoisted_3)
          ], true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "description", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.description), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "actions", {}, () => [
        (_ctx.hasGoback || _ctx.gobackShow)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "exception-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
            }, "上一页"))
          : _createCommentVNode("", true),
        _createElementVNode("button", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: {path: '/'},
            replace: "",
            exact: "",
            tag: "span"
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回首页")
            ]),
            _: 1
          })
        ])
      ], true)
    ])
  ]))
}